import { render, staticRenderFns } from "./ProListItem.vue?vue&type=template&id=134c7afa&scoped=true"
import script from "./ProListItem.vue?vue&type=script&lang=js"
export * from "./ProListItem.vue?vue&type=script&lang=js"
import style0 from "./ProListItem.vue?vue&type=style&index=0&id=134c7afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c7afa",
  null
  
)

export default component.exports